let GWP = {};
const GWPSchema = document.querySelector('[data-GWP-schema]');
if(GWPSchema){
  GWP = JSON.parse(GWPSchema.innerHTML);
}
class customGWPJS {
    constructor() {
        this.ajaxCart = document.querySelector('cart-form');
    }
  
    cartGWP(){
        this.ajaxCart = document.querySelector('cart-form');
        const cart = window.globalSpace.cart;
        let  GWPGift = false;
        let [threashouldValue, existedFreeProduct, existedFreeProductLine] = [null, null, null];
        let [finalThreshouldAmount, originalThreshouldAmount, updateQty] = [null, null, false];
        let [eligibleThreshould, eligibleFreeProduct, eligibleFreeProductJSON, eligibleFreeProduct_2, eligibleFreeProductJSON_2, cartTotal] = [null, null, null, null, null, 0];
        cart.items.forEach((product, index)=>{
            if(product.properties && product.properties['product_type'] == 'GWP Gift'){
                GWPGift = true;
                existedFreeProductLine = index + 1;
                existedFreeProduct = product.variant_id;
                if(product.quantity > 1){
                    updateQty = true;
                }
                if(product.variant_id == GWP.threashould_1['gwp_pro'] || product.variant_id == GWP.threashould_1['gwp_pro_2']){
                    threashouldValue = 1;
                }
            }else{
                if(product.product_type != 'Gift Card'){
                    cartTotal = cartTotal + product.final_line_price;
                }
            }
        });
        if(GWP.enable == 'true' && cartTotal >= GWP.threashould_1['amount']){
            eligibleThreshould = 1;
            let selectedThreashould = GWP[`threashould_${eligibleThreshould}`];
            [eligibleFreeProduct,eligibleFreeProductJSON, eligibleFreeProduct_2 ,eligibleFreeProductJSON_2] = [selectedThreashould.gwp_pro, selectedThreashould.gwp_pro_JSON, selectedThreashould.gwp_pro_2, selectedThreashould.gwp_pro_JSON_2];
            [finalThreshouldAmount,originalThreshouldAmount] = [selectedThreashould.amount, selectedThreashould.original_amount];
        }
        let removeProduct = JSON.stringify({
            line: existedFreeProductLine,
            quantity: 0
        });
        if((GWP == undefined || eligibleThreshould == null) && GWPGift) {
            console.log("gwp 2....")
            this.updateGWPvariant(removeProduct, ()=> {
                if(this.ajaxCart) this.ajaxCart.getCartData();
            });
        }else if((threashouldValue && threashouldValue != eligibleThreshould && (eligibleFreeProduct != null || eligibleFreeProduct_2 != null)) 
        || (existedFreeProduct != null && existedFreeProduct != eligibleFreeProduct && existedFreeProduct != eligibleFreeProduct_2)){
            console.log("in else if")
            this.updateGWPvariant(removeProduct, ()=> {
                if(this.ajaxCart) this.ajaxCart.getCartData();
                this.showFreeProduct(originalThreshouldAmount, finalThreshouldAmount, eligibleFreeProductJSON, eligibleFreeProductJSON_2);
            });
        }
        else if(updateQty){
            console.log("els eif 2")
            let updateProduct = JSON.stringify({
                line: existedFreeProductLine,
                quantity: 1
            });
            this.updateGWPvariant(updateProduct, ()=>{
                if(this.ajaxCart) this.ajaxCart.getCartData();
            });
        }else if(eligibleThreshould != null && eligibleFreeProduct != null && !GWPGift){
            this.showFreeProduct(originalThreshouldAmount, finalThreshouldAmount, eligibleFreeProductJSON, eligibleFreeProductJSON_2);
        } else {
            
            const freeGiftParent = document.querySelector('[data-freeGift]');
            if (freeGiftParent) {
                freeGiftParent.style.display = 'none';
                freeGiftParent.innerHTML = '';
            }
        }
    }
    updateGWPvariant(body, callback) {
        let checkoutBtn = document.querySelector('.checkout-btn');
        let fetchCart = fetch(`${routes.cart_change_url}`, { ...Utility.fetchConfig(), ...{ body }});
        fetchCart.then(response => {
          return response.json();
        }).then(response => {
          if (typeof callback == "function") return callback(response);
        }).catch((e) => {
          console.error(e);
          return callback(e);
        }).finally(() => {
              if(checkoutBtn){ checkoutBtn.classList.remove('disabled'); }
        });

    }
    showFreeProduct(originalThreshouldAmount, finalThreshouldAmount, eligibleFreeProductJSON, eligibleFreeProductJSON_2){
      
        if(eligibleFreeProductJSON == null && eligibleFreeProductJSON_2 == null){
            return;
        }

        let freeProductsHTML = `
        <div class="list-item d-flex gap-2 mt-4">
          <div class="card-img flex-shrink-0" style="width: 100px;">
            <div class="d-block">
              <img class="img-fluid item-img" src="${eligibleFreeProductJSON.featured_image}" loading="lazy" width="75" height="95" />
            </div>
          </div>
          <div class="card-body">
            <div class="cart-item-text ">
              <p class="card-title fw-semibold fs-md mb-1 d-inline-block" style="line-height: 1.3;">${eligibleFreeProductJSON.title}</p>
              <div class="cart-price">
                <span class="orgi_price ajaxcart__price">$0  <del>${Utility.formatMoney(eligibleFreeProductJSON.compare_at_price, window.globalSpace.money_format)}</del></span>
              </div>
              <div class="quantity-box mt-3">
                <button type="button" name="add" class="btn btn-primary btn-sm add-to-cart" data-originalThreshouldAmount="${originalThreshouldAmount}" data-addID="${eligibleFreeProductJSON.variants[0].id}" data-addFreeItem><span>Add to cart</span></button>
              </div>
            </div>
          </div>
        </div>`;
      
      if (eligibleFreeProductJSON_2) {
        freeProductsHTML += `
        <div class="list-item d-flex gap-2 mt-4 pt-3">
          <div class="card-img flex-shrink-0" style="width: 100px;">
            <div class="d-block">
              <img class="img-fluid item-img" src="${eligibleFreeProductJSON_2.featured_image}" loading="lazy" width="75" height="95" />
            </div>
          </div>
          <div class="card-body">
            <div class="cart-item-text ">
              <p class="card-title fw-semibold fs-md mb-1 d-inline-block" style="line-height: 1.3;">${eligibleFreeProductJSON_2.title}</p>
              <div class="cart-price">
                <span class="orgi_price ajaxcart__price">$0  <del>${Utility.formatMoney(eligibleFreeProductJSON_2.compare_at_price, window.globalSpace.money_format)}</del></span>
              </div>
              <div class="quantity-box mt-3">
                <button type="button" name="add" class="btn btn-primary btn-sm add-to-cart" data-originalThreshouldAmount="${originalThreshouldAmount}" data-addID="${eligibleFreeProductJSON_2.variants[0].id}" data-addFreeItem><span>Add to cart</span></button>
              </div>
            </div>
          </div>
        </div>`;
      }
      

        let freeProductwrapperHTML = `<div class=""><div class="col-12 gift_prod_heading mt-3">
                                        <div class="general-text mb-5 fw-medium" style="font-size:14px;">You are eligible for Free Gift for spent over ${Utility.formatMoney(finalThreshouldAmount, window.globalSpace.money_format)}</div>
                                        </div>
                                        <div class="">${freeProductsHTML}</div>`;
        const freeGiftParent = document.querySelector('[data-freeGift]');
        if(freeGiftParent){
            freeGiftParent.innerHTML = freeProductwrapperHTML;
            freeGiftParent.style.display = 'block';
        }
        const addItemBtns = document.querySelectorAll('[data-addFreeItem]');
        if(addItemBtns.length == 0) return;
        addItemBtns.forEach(addBtn => {
            
            addBtn.addEventListener('click', (event)=>{
                event.preventDefault();
                const currentTarget = event.currentTarget;
                const body = JSON.stringify({
                    id: currentTarget.getAttribute('data-addid'),
                    quantity: 1,
                    properties: {
                        product_type: 'GWP Gift',
                        spend_over: currentTarget.getAttribute('data-originalThreshouldAmount')
                    }
                });
                let fetchCart = fetch(`${window.routes.cart_add_url}`, { ...Utility.fetchConfig(), ...{ body }});
                console.log(fetchCart , "cart")
                fetchCart.then(response => {
                    return response.json();
                }).then(_response => {
                    if(this.ajaxCart) this.ajaxCart.getCartData();
                    console.log("responce" , _response);
                    // hide block once product added to cart
                    freeGiftParent.style.display = 'none';
                    freeGiftParent.innerHTML = '';
                }).catch((e) => {
                    console.error(e);
                });
            });
        });
    }
}

typeof customGWPJS !== 'undefined' && new customGWPJS();

if (customGWPJS != null) {
    const newCustomGWP = new customGWPJS();
    newCustomGWP.cartGWP()
}